import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FilterRevamp from "./component";
import {fetchCarList, updateSSRStatus, reloadCarList, resetCarList} from "../car-listing/actions";
import { fetchWishlistedCarsList } from "../my-wishlist/actions";
import { clearAllFilters, setMarketingCategory, updateSelectedOnScreenFilter, updateAllFiltersVisibility, updateSortModalVisibility,
    fetchListingCount, setListingFBEvents, updateAppliedFilters, updateAppliedSuggestions, updateFilterOptionData, updateSelectedFilterSuggestionToDefault, clearSuggestions, clearSelectedFilter, replaceSelectedFilter, updateAllSubFilterOptions, updateSelectedSuggestions } from "../filters/actions";
import { getInhouseEligibility, getDrivaPreApprovalLoanDetails, getPreApprovalLoanDetails } from "../pre-approval-financing-flow/pre-approval-loan-wrapper/actions";
import { getTradeInToggleVisible, setViewCarsButtonTriggered } from "../trade-in-your-car-wrapper/actions";

const mapStateToProps = ({
    carListing: {
        content,
        totalCars,
        page,
        isLoading,
        isSSR,
        shouldReloadList,
        personalised,
        ipDetectedState,
        metaContent
    },
    filters: {
        allFilters,
        urlOptions,
        selectedFilters,
        appliedFilters,
        appliedSuggestions,
        marketCategoryEvent,
        selectedOnScreenFilter,
        fbEventType,
        isSortModalOpen,
        selectedSort,
        removedMakeFilter,
        config
    },
    preApprovalLoan: {
        financeData: {
            loanType
        },
        inHouseFinanceEligibility,
        preApproved,
        quotesAvailable
    },
    abExperiment: {
        showInHouseFinance,
        showTestDriveV2
    },
    tradeIn: {
        userTradeInData,
        tradeInToggleSelected,
        isViewCarsButtonTriggered
    },
    user: {isLoggedIn},
    config: {
        saleConfig
    }
}) => ({
    content,
    totalCars,
    page,
    isLoading,
    config,
    allFilters,
    loanType,
    isSSR,
    urlOptions,
    selectedFilters,
    appliedFilters,
    appliedSuggestions,
    shouldReloadList,
    personalised,
    ipDetectedState,
    inHouseFinanceEligibility,
    preApproved,
    showInHouseFinance,
    userTradeInData,
    tradeInToggleSelected,
    quotesAvailable,
    marketCategoryEvent,
    selectedOnScreenFilter,
    fbEventType,
    metaContent,
    isSortModalOpen,
    selectedSort,
    removedMakeFilter,
    isViewCarsButtonTriggered,
    showTestDriveV2,
    isLoggedIn,
    saleConfig
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCarListConnect: fetchCarList,
    updateSSRStatusConnect: updateSSRStatus,
    reloadCarListConnect: reloadCarList,
    resetCarListConnect: resetCarList,
    fetchWishlistedCarsListConnect: fetchWishlistedCarsList,
    clearAllFiltersConnect: clearAllFilters,
    getInhouseEligibilityConnect: getInhouseEligibility,
    getDrivaPreApprovalLoanDetailsConnect: getDrivaPreApprovalLoanDetails,
    getPreApprovalLoanDetailsConnect: getPreApprovalLoanDetails,
    setMarketingCategoryConnect: setMarketingCategory,
    updateSelectedOnScreenFilterConnect: updateSelectedOnScreenFilter,
    updateAllFiltersVisibilityConnect: updateAllFiltersVisibility,
    updateSortModalVisibilityConnect: updateSortModalVisibility,

    updateFilterOptionDataConnect: updateFilterOptionData,
    updateSelectedFilterSuggestionToDefaultConnect: updateSelectedFilterSuggestionToDefault,
    fetchListingCountConnect: fetchListingCount,
    updateAppliedFiltersConnect: updateAppliedFilters,
    updateAppliedSuggestionsConnect: updateAppliedSuggestions,
    setListingFBEventsConnect: setListingFBEvents,
    clearSuggestionsConnect: clearSuggestions,
    clearSelectedFilterConnect: clearSelectedFilter,
    replaceSelectedFilterConnect: replaceSelectedFilter,
    updateAllSubFilterOptionsConnect: updateAllSubFilterOptions,
    updateSelectedSuggestionsConnect: updateSelectedSuggestions,
    getTradeInToggleVisibleConnect: getTradeInToggleVisible,
    setViewCarsButtonTriggeredConnect: setViewCarsButtonTriggered

}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FilterRevamp);
